module.exports = __webpack_public_path__ + "static/img/centralservidor-logo-texto.a730e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/centralservidor-logo-texto.png
// module id = VQf9
// module chunks = 5